var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _circle2, _path8, _circle3, _path9, _rect, _path0, _path1, _path10, _path11, _path12, _circle4, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSignUpFormImage = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 547.729,
    height: 491.5,
    viewBox: "0 0 547.729 491.5",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#575a89}.prefix__cls-2{fill:#3f3d56}.prefix__cls-3{fill:#fff}.prefix__cls-4{fill:#9aaeff}.prefix__cls-5{fill:#fbbebe}.prefix__cls-6{fill:#2f2e41}.prefix__cls-7{fill:#e6e6e6}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_675",
    "data-name": "Group 675",
    transform: "translate(-525 -244)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6431",
    d: "M268.8 629.09l-6.117-24.128a313.323 313.323 0 00-33.24-11.926l-.772 11.213-3.133-12.349c-14.008-4-23.538-5.762-23.538-5.762s12.873 48.951 39.872 86.374l31.46 5.526-24.44 3.524a126.774 126.774 0 0010.933 11.586c39.276 36.457 83.023 53.184 97.711 37.36s-5.245-58.205-44.522-94.662c-12.176-11.3-27.472-20.372-42.783-27.51z",
    className: "prefix__cls-1",
    "data-name": "Path 6431",
    transform: "translate(323 -3.574)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6432",
    d: "M362.724 578.162l7.235-23.817a313.293 313.293 0 00-22.291-27.391l-6.457 9.2 3.7-12.194c-9.924-10.665-17.171-17.1-17.171-17.1s-14.283 48.558-10.515 94.55L341.3 622.4l-22.744-9.617a126.759 126.759 0 003.37 15.569c14.778 51.511 43.581 88.442 64.333 82.488s25.6-52.538 10.818-104.048c-4.581-15.969-12.987-31.639-22.4-45.664z",
    className: "prefix__cls-1",
    "data-name": "Path 6432",
    transform: "translate(287.258 21.151)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6434",
    d: "M969.237 757.87l6.438-1.856a84.33 84.33 0 002.919-9.046l-3.023-.11 3.3-.95c.954-3.8 1.345-6.383 1.345-6.383s-13.06 3.889-22.894 11.475l-1.213 8.512-1.161-6.545a34.119 34.119 0 00-3.022 3.042c-9.466 10.884-13.586 22.8-9.2 26.612s15.613-1.917 25.08-12.8a44.92 44.92 0 007.029-11.749z",
    className: "prefix__cls-1",
    "data-name": "Path 6434",
    transform: "translate(92.516 -51.417)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6435",
    d: "M616.168 127.344v421.231a33.235 33.235 0 01-33.223 33.23h-163.7A33.24 33.24 0 01386 548.571V127.344a33.239 33.239 0 0133.243-33.23H439.1a15.8 15.8 0 0014.62 21.756h93.328a15.8 15.8 0 0014.619-21.756h21.271a33.235 33.235 0 0133.229 33.223z",
    className: "prefix__cls-2",
    "data-name": "Path 6435",
    transform: "translate(265.611 149.886)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6436",
    d: "M512.276 340.2a16.431 16.431 0 018.223-14.237 16.44 16.44 0 100 28.473 16.429 16.429 0 01-8.223-14.236z",
    className: "prefix__cls-3",
    "data-name": "Path 6436",
    transform: "translate(231.353 78.26)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6437",
    d: "M542.312 340.2a16.431 16.431 0 018.224-14.237 16.44 16.44 0 100 28.473 16.429 16.429 0 01-8.224-14.236z",
    className: "prefix__cls-3",
    "data-name": "Path 6437",
    transform: "translate(221.985 78.26)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_3677",
    cx: 16.44,
    cy: 16.44,
    r: 16.44,
    className: "prefix__cls-4",
    "data-name": "Ellipse 3677",
    transform: "translate(768.055 402.022)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1795",
    d: "M0 0H146.954V1.376H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 1795",
    transform: "translate(693.292 526.056)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_3678",
    cx: 4.641,
    cy: 4.641,
    r: 4.641,
    className: "prefix__cls-4",
    "data-name": "Ellipse 3678",
    transform: "translate(693.292 508.181)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1796",
    d: "M0 0H146.954V1.376H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 1796",
    transform: "translate(693.292 572.462)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_3679",
    cx: 4.641,
    cy: 4.641,
    r: 4.641,
    className: "prefix__cls-4",
    "data-name": "Ellipse 3679",
    transform: "translate(693.292 554.588)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6438",
    d: "M574.055 375.729h-95.816a3.445 3.445 0 01-3.44-3.44v-95.817a3.445 3.445 0 013.44-3.44h95.816a3.445 3.445 0 013.441 3.44v95.816a3.445 3.445 0 01-3.441 3.441zm-95.816-101.321a2.067 2.067 0 00-2.064 2.064v95.816a2.066 2.066 0 002.064 2.064h95.816a2.067 2.067 0 002.064-2.064v-95.816a2.067 2.067 0 00-2.064-2.064z",
    className: "prefix__cls-3",
    "data-name": "Path 6438",
    transform: "translate(237.915 94.082)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_1797",
    width: 51.821,
    height: 21.656,
    className: "prefix__cls-4",
    "data-name": "Rectangle 1797",
    rx: 4,
    transform: "translate(788.426 603.315)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1798",
    d: "M0 0H547.182V1.376H0z",
    className: "prefix__cls-2",
    "data-name": "Rectangle 1798",
    transform: "translate(525.547 731.016)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_673",
    "data-name": "Group 673",
    transform: "translate(-17629.215 -3126.621)"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6448",
    d: "M900.954 460.782l-6.644 24.679s-3.322 19.933 2.373 20.408 4.271-19.933 4.271-19.933l10.916-17.085z",
    className: "prefix__cls-5",
    "data-name": "Path 6448",
    transform: "translate(17631.867 3174.007)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6449",
    d: "M952.01 474.47v-7.732l-45.078-3.038-7.132 45.563s-.949 45.424 2.373 68.619 9.966 77.318 9.966 77.318h30.374l-7.594-112.594L969.1 655.2l35.595-4.349-41.295-132.89s.475-24.645-11.39-43.491z",
    className: "prefix__cls-6",
    "data-name": "Path 6449",
    transform: "translate(17630.17 3173.225)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6450",
    d: "M917.294 718.2l-1.9 14.712-2.848 10.441s-13.289 2.848-5.221 7.593 15.662 0 15.662 0l6.17-8.543v14.712h9.492v-20.881l-7.119-15.662z",
    className: "prefix__cls-6",
    "data-name": "Path 6450",
    transform: "translate(17628.816 3105.005)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6451",
    d: "M997.7 718.2l-1.9 14.712-2.848 10.441s-13.289 2.848-5.221 7.593 15.662 0 15.662 0l6.17-8.543v14.712h9.492v-20.881l-7.119-15.662z",
    className: "prefix__cls-6",
    "data-name": "Path 6451",
    transform: "translate(17607.264 3105.005)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_3698",
    cx: 16.136,
    cy: 16.136,
    r: 16.136,
    className: "prefix__cls-5",
    "data-name": "Ellipse 3698",
    transform: "translate(18547.295 3525.395)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6452",
    d: "M799.475 228.107l13.289 16.136-16.136 6.17-7.594-15.187z",
    className: "prefix__cls-5",
    "data-name": "Path 6452",
    transform: "translate(17774.633 3320.307)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6453",
    d: "M937.657 363.326l2.295-.631s11.943-7.437 15.265-6.963 13.763 10.916 11.865 25.154 1.9 67.393-5.7 65.494-9.967-3.322-9.967-3.322l-9.017-4.271-8.543 2.373s-5.22-3.322-9.492-2.373-18.035-3.8-18.035-3.8z",
    className: "prefix__cls-7",
    "data-name": "Path 6453",
    transform: "translate(17628.387 3202.172)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6454",
    d: "M939.2 367.585s-10.724-5.085-15.47 2.515-18.03 47.931-18.03 47.931l-6.17 18.509 15.187 9.017 29.9-55.053s4.365-16.414-5.417-22.919z",
    className: "prefix__cls-7",
    "data-name": "Path 6454",
    transform: "translate(17630.211 3199.436)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6455",
    d: "M936.359 326.715c-1.014-1.561-.5-3.684-1.213-5.4-1.117-2.7-4.588-3.334-7.5-3.581a22.36 22.36 0 00-5.812.016 5.578 5.578 0 00-4.031 2.922c-.431.864-.322-1.844-.046-5.32a16.8 16.8 0 0112.887-15.033l.122-.028a31.862 31.862 0 0110.818-1 14.076 14.076 0 019.474 4.841c1.031 1.305 1.76 2.845 2.911 4.046 2.022 2.11 5.02 2.878 7.774 3.857a23.456 23.456 0 018.524 4.918 12.714 12.714 0 014.12 8.737c.058 3.855-2.394 7.834-6.346 8.594a4.437 4.437 0 00-1.9.818c-3.773 2.926.531 5.988.5 9.282-.025 2.748-3.084 4.54-5.83 4.668A11.062 11.062 0 01949.8 340.3a23.056 23.056 0 01.175-6.849c.308-2.607-5.305-8.745-1.6-4.246a6.451 6.451 0 011.418 2.985c.617 3.594-2.653 4.8-4.716 6.795a8.546 8.546 0 00-2.069 8.8 9.853 9.853 0 01-1.791-12.442c.664-1.019 1.521-1.905 2.15-2.946.983-1.624 1.254-5.155-1.5-5.058-1.958.061-3.998 1.699-5.508-.624z",
    className: "prefix__cls-6",
    "data-name": "Path 6455",
    transform: "translate(17625.389 3217.334)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6456",
    d: "M788.5 305.607l-21.832 34.548 20.663-38.046z",
    "data-name": "Path 6456",
    transform: "translate(17780.631 3300.47)",
    style: {
      opacity: 0.2
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSignUpFormImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/signUpFormImage.743b5cc4cc5ccc5aa2f3dfc9a7395022.svg";